module.exports = __webpack_public_path__ + "img/panelView_strongBg_2_2.07c23ecf.png";